<div *ngFor="let indicator of statusIndicators">
    {{ indicator.name }}:
    <strong [ngClass]="indicator.status ? 'green-color' : 'warning-color'">{{ indicator.statusText }}</strong>
</div>
